/*
  Reviews marquee, driven by script since 2026-10-04 (Jin: "on mobile, allow the review carousel to
  be scrolled, but keep the animation going even upon scrolling").

  The CSS marquee it replaces paused on :hover and :focus-within, and a tap on a phone sets both, so
  one touch stopped it for good. Here the row is a real scroller: a finger moves it natively, and the
  moment the finger lifts and the fling settles the drift picks up again from wherever it was left.

  The list prints twice, so position p and p + H look identical (H is one list's width). The drift
  wraps p back by H; before a touch, p is moved to the copy nearest the middle so a swipe either way
  has room. Desktop with a mouse still pauses on hover, and keyboard focus pauses it, so a review can
  be read. Under reduced motion none of this runs and the CSS makes it a plain sideways row.
*/
(function () {
  if (window.scptReviews) return;
  window.scptReviews = true;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mouse = window.matchMedia('(hover: hover) and (pointer: fine)');

  function start(view) {
    if (view.dataset.scptMarquee) return;
    view.dataset.scptMarquee = '1';
    var list = view.querySelector('.scpt-reviews__list');
    if (!list) return;
    var cards = list.children.length || 1;
    var H = 0, W = 0, pos = 0, set = -1, last = 0, held = false, hover = false, focus = false;
    var userAt = 0, onScreen = true, raf = 0;

    function measure() {
      H = list.getBoundingClientRect().width;
      W = view.clientWidth;
    }
    // The copy of p nearest the middle of the scroll range, so a swipe either way has room.
    function centre(p) {
      var mid = (2 * H - W) / 2, best = p;
      [p - H, p + H].forEach(function (q) {
        if (q >= 0 && q <= 2 * H - W && Math.abs(q - mid) < Math.abs(best - mid)) best = q;
      });
      return best;
    }
    function put(p) {
      pos = p; view.scrollLeft = p; set = view.scrollLeft;
    }
    function tick(t) {
      raf = 0;
      if (still.matches || !onScreen || document.hidden) { last = 0; return; }
      var dt = last ? Math.min(t - last, 64) : 0;
      last = t;
      var idle = !held && !hover && !focus && t - userAt > 140;
      if (idle && H > W) {
        pos += (H / (cards * 7)) * (dt / 1000);
        if (pos >= H) pos -= H;
        put(pos);
      }
      raf = requestAnimationFrame(tick);
    }
    function run() {
      if (!raf) raf = requestAnimationFrame(tick);
    }

    // Anything that moved the row other than us is the visitor: follow it.
    view.addEventListener('scroll', function () {
      if (Math.abs(view.scrollLeft - set) > 2) {
        pos = view.scrollLeft; set = pos;
        userAt = performance.now();
      }
    }, { passive: true });
    view.addEventListener('touchstart', function () {
      held = true; measure(); put(centre(view.scrollLeft));
    }, { passive: true });
    function release() { held = false; userAt = performance.now(); run(); }
    view.addEventListener('touchend', release, { passive: true });
    view.addEventListener('touchcancel', release, { passive: true });
    view.addEventListener('mouseenter', function () { if (mouse.matches) hover = true; });
    view.addEventListener('mouseleave', function () { hover = false; run(); });
    view.addEventListener('focusin', function () { focus = view.matches(':focus-visible'); });
    view.addEventListener('focusout', function () { focus = false; run(); });
    window.addEventListener('resize', measure, { passive: true });
    document.addEventListener('visibilitychange', run);
    still.addEventListener && still.addEventListener('change', run);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        onScreen = es[0].isIntersecting; if (onScreen) run();
      }).observe(view);
    }
    measure(); put(0); run();
  }

  function init() {
    document.querySelectorAll('.scpt-reviews__viewport').forEach(start);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // The theme editor re-renders a section in place.
  document.addEventListener('shopify:section:load', init);
})();
